<div class="oil-app-wrapper">
    <div class="iframe-container">
      <iframe 
        [src]="oilAppUrl | safeUrl"
        allowfullscreen>
      </iframe>
    </div>
  </div>
  